



























import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";

export default {
  name: "BaseImageCropper",
  components: { VueCropper },
  data: function () {
    return {
      rendered: true,
      loading: true,
    };
  },
  props: {
    imageSrc: {
      type: String,
      required: true,
    },
    aspectRatio: {
      type: Number,
      default: 1 / 1,
    },
  },
  mounted() {},
  watch: {
    imageSrc: function () {
      this.$refs.cropper.reset();
      this.$forceUpdate();
      this.rendered = false;
      this.loading = true;
      setTimeout(() => {
        this.rendered = true;
      }, 50);
    },
  },
  methods: {
    getCroppedImageBase64() {
      const croppedCanvas = this.$refs.cropper.getCroppedCanvas();
      const croppedImageBase64 = croppedCanvas.toDataURL("image/png");
      return croppedImageBase64;
    },
    fitToFrame() {
      const boxData = this.$refs.cropper.getCropBoxData();
      this.$refs.cropper.setCanvasData(boxData);
      const canvasData = this.$refs.cropper.getCanvasData();
      const difHeight = boxData.height - canvasData.height;
      if (difHeight > 0) {
        this.$refs.cropper.setCanvasData({
          ...canvasData,
          top: canvasData.top + difHeight / 2,
        });
      } else if (difHeight < 0) {
        const targetWidth =
          boxData.width * (boxData.height / canvasData.height);
        this.$refs.cropper.setCanvasData({
          ...canvasData,
          left: boxData.left + (boxData.width - targetWidth) / 2,
          height: boxData.height,
          width: targetWidth,
        });
      }
    },
    fillToFrame() {
      const boxData = this.$refs.cropper.getCropBoxData();
      this.$refs.cropper.setCanvasData(boxData);
      const canvasData = this.$refs.cropper.getCanvasData();
      const difHeight = boxData.height - canvasData.height;
      if (difHeight > 0) {
        const targetWidth =
          boxData.width * (boxData.height / canvasData.height);
        this.$refs.cropper.setCanvasData({
          ...canvasData,
          left: boxData.left - (targetWidth - boxData.width) / 2,
          width: targetWidth,
          height: boxData.height,
        });
      } else if (difHeight < 0) {
        this.$refs.cropper.setCanvasData({
          ...canvasData,
          top: boxData.top + difHeight / 2,
        });
      }
    },
    zoomIn() {
      this.$refs.cropper.relativeZoom(0.1); //.zoom(0.1);
    },
    zoomOut() {
      this.$refs.cropper.relativeZoom(-0.1);
    },
    ready() {
      this.loading = false;
      this.fitToFrame();
    },
  },
};
